module.exports = __webpack_public_path__ + "static/Gerda-hidden-b06511a7b01dd76ae992e7eed7512039.jpg";